import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      width: '100%',
      color: palette.text.white
    },
    legendary: {
      fontWeight: 500,
      color: palette.text.primary,
      background: palette.background.underBox,
      borderRadius: palette.borderRadius.default,
      display: 'flex',
      flexDirection: 'column',
      padding: '10px',
      gap: '20px',
      '& > span:last-child': {
        fontWeight: (props: { highlightLast: boolean }) =>
          props.highlightLast && 600
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
